<template>
  <div v-if="dataLoaded">
    <div class="row q-mb-lg">
      <q-btn
        class="capitalize ctrl-button"
        color="grey-5"
        :label="getString('action.toOverview')"
        @click="$router.push(`/${moduleContext}`)"
        icon="keyboard_backspace"
      />
    </div>
    <div class="row gutter-sm q-mb-lg">
      <!-- Files names -->
      <div class="col-md-6 col-sm-12 col-xs-12">
        <p class="card-title">{{ getString('module.spare-part-logs.detail.affected') }} :</p>
        <div class="card-block">
          <div v-for="(name, key) in data.names" :key="key">{{ name }}</div>
        </div>
      </div>
      <!-- General Information -->
      <div class="col-md-6 col-sm-12 col-xs-12">
        <p class="card-title">
          {{ getString('module.logs.details.general.title') }}
        </p>
        <div class="card-block">
          <!-- Level -->
          <div class="row">
            <div class="col-3">
              <p class="card-data data-title">
                {{ getString('module.logs.details.general.level') }}
              </p>
            </div>
            <div class="col-9">
              <div style="display: inline-flex">
                <div
                  class="log-message"
                  :class="messageClass(data.level)"
                ></div>
                <p class="card-data data-content">
                  {{ data.level | capitalize }}
                </p>
              </div>
            </div>
          </div>
          <!-- Message -->
          <div class="row">
            <div class="col-3">
              <p class="card-data data-title">
                {{ getString('module.logs.details.general.message') }}
              </p>
            </div>
            <div class="col-9">
              <p class="card-data data-content">{{ data.message }}</p>
            </div>
          </div>
          <!-- Timestamp -->
          <div class="row">
            <div class="col-3">
              <p class="card-data data-title">
                {{ getString('datetime.label') }}
              </p>
            </div>
            <div class="col-9">
              <p class="card-data data-content">{{ formatDatetime }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- Logged by -->
      <div class="col-md-6 col-sm-12 col-xs-12">
        <p class="card-title">{{ getString('module.spare-part-logs.detail.data') }} :</p>
        <div class="card-block">
          <!-- File -->
          <div class="row" v-for="(item, key) in data.data" :key="key">
            <div class="col-3">
              <p class="card-data data-title">{{ key }} :</p>
            </div>
            <div v-if="typeof item ==='string'" class="col-9">
              {{ item }}
            </div>
            <div v-else-if="typeof item ==='object'" class="col-9">
              <p
                v-for="(name, k) in item"
                :key="k"
                class="card-data data-content"
              >
                {{ name }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

// Mixins
import fetchDetail from '@/mixins/detailViews/fetchDetail';
import getString from '@/helpers/GetStrings';
import common from './common';

export default {
  mixins: [fetchDetail, common],
  name: 'SparePartLogsDetail',
  data() {
    return {
      dataLoaded: false,
      data: null,
    };
  },
  methods: {
    getString,
    messageClass(level) {
      return `${level}-level`;
    },
  },
  computed: {
    // Format time (callback defined in columnsDefinition)
    formatDatetime() {
      // Unix timestamp formatted as "2018-16-05, 11:36 pm.."
      // return value > 0 ? moment(value).format('YYYY-DD-MM, h:mm a') : '-';
      return moment(this.data.updated_at.date).format('YYYY-DD-MM, h:mm a');
    },
  },
  filters: {
    capitalize(value) {
      if (!value) return '';
      value = value.toString();
      return value.charAt(0).toUpperCase() + value.slice(1);
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~variables';

.data-title {
  font-weight: 700;
}

.data-content {
  word-break: break-all;
}

p.card-data {
  margin: 0px 0 6px !important;
}

</style>
